// Code generated by codegen. DO NOT EDIT!
//
// Use 'yarn codegen' to regenerate this file based on schema and
// file defined operations.

import * as Types from "../../../../../gql/types";
import { SpaceCategoryFeaturesSpaceCategoryFragmentDoc } from "../../../../_shared/SpaceCategoryFeatures/SpaceCategoryFeatures.generated";
export type AssetHomeCardSpaceSpaceCategoryFragment = {
  __typename?: "SpaceCategory";
  id: string;
  name: string;
  capacity: number;
  size: number;
  bedrooms: number;
  bathrooms: number;
  terrace: boolean;
  balcony: boolean;
  position: number;
  entireSpace: boolean;
  entireSpaceCapacity: number;
  genderRestriction: Types.SpaceCategoryGenderRestriction;
  images: Array<{ __typename?: "Image"; url: string }> | null;
  beds: {
    __typename?: "SpaceCategoryBeds";
    single: number;
    double: number;
    twin: number;
    bunkBed: number;
    sofaBed: number;
    twinOrDouble: number;
    trundleDoubleBed: number;
    foldingDoubleBed: number;
  };
};

export type AssetHomeCardSpaceAvailableRateFragment = {
  __typename?: "AvailableRateV2";
  perNightPrice: { amount: number; currency: string };
  originalPerNightPrice: { amount: number; currency: string } | null;
  promoName: string | null;
  enabledByVoucherCode: boolean | null;
};

export const AssetHomeCardSpaceSpaceCategoryFragmentDoc = `
    fragment AssetHomeCardSpaceSpaceCategory on SpaceCategory {
  id
  name
  images {
    url
  }
  ...SpaceCategoryFeaturesSpaceCategory
}
    `;
export const AssetHomeCardSpaceAvailableRateFragmentDoc = `
    fragment AssetHomeCardSpaceAvailableRate on AvailableRateV2 {
  perNightPrice
  originalPerNightPrice
  promoName
  enabledByVoucherCode
}
    `;
